"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyBreakdownSchema = exports.SegmentBreakdownSchema = exports.DimensionBreakdownSchema = exports.SegmentBucketSchema = exports.AnySegmentReducerSchema = exports.SegmentReducerPercentileSchema = exports.SegmentReducerAggregationSchema = void 0;
const zod_1 = require("zod");
const condition_1 = require("../condition");
exports.SegmentReducerAggregationSchema = zod_1.z.literal('average');
exports.SegmentReducerPercentileSchema = zod_1.z.object({
    type: zod_1.z.literal('percentile'),
    value: zod_1.z.number(),
});
exports.AnySegmentReducerSchema = zod_1.z.union([
    exports.SegmentReducerAggregationSchema,
    exports.SegmentReducerPercentileSchema,
]);
exports.SegmentBucketSchema = zod_1.z.object({
    key: zod_1.z.string(),
    reducer: exports.AnySegmentReducerSchema,
    filter: condition_1.AnyConditionExprSchema.optional(),
});
exports.DimensionBreakdownSchema = zod_1.z.object({
    kind: zod_1.z.literal('dimension'),
    key: zod_1.z.string(),
});
exports.SegmentBreakdownSchema = zod_1.z.object({
    kind: zod_1.z.literal('segment'),
    buckets: zod_1.z.array(exports.SegmentBucketSchema),
});
exports.AnyBreakdownSchema = zod_1.z.discriminatedUnion('kind', [
    exports.DimensionBreakdownSchema,
    exports.SegmentBreakdownSchema,
]);
//# sourceMappingURL=breakdownSchema.js.map